import { render } from "./sidebar.vue?vue&type=template&id=3adde5be&scoped=true"
import script from "./sidebar.vue?vue&type=script&lang=js"
export * from "./sidebar.vue?vue&type=script&lang=js"

import "./sidebar.vue?vue&type=style&index=0&id=3adde5be&lang=css&scoped=true"

import exportComponent from "/var/www/test.mciafc.com/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3adde5be"]])

export default __exports__